import { useContext, useState } from "react";

import { Listbox } from "@headlessui/react";

import { ModalPackageForm } from "common/contexts";

import ButtonNew from "components/atoms/ButtonNew/index";
import { FaCaretRight } from "components/atoms/Icon/fa/FaCaretRight";
import { FiChevronDown } from "components/atoms/Icon/fi/FiChevronDown";

const Step1 = () => {
  const {
    register,
    isSubmitting,
    errors,
    step,
    setStep,
    getValues,
    suffix_data,
    isReserved,
    selected,
    setSelected,
  } = useContext(ModalPackageForm);
  const [companyNameError, setCompanyNameError] = useState();

  return (
    <>
      <div
        className={`m-auto  flex  max-w-xs ${
          isReserved ? "flex-col-reverse" : "flex-col"
        }`}
      >
        <input
          {...register("company_name", {
            required: {
              value: true,
              message: "This field is required",
            },
          })}
          disabled={isSubmitting}
          className={
            " mt-6  w-full rounded-full border-0 px-4  py-2  text-bbc-gray focus:outline-0 focus:ring-0"
          }
          required
          type="text"
          placeholder="Your proposed company name"
        />
        {companyNameError && (
          <span className="block  pt-2 pl-2 text-left text-sm text-red-500">
            This field is required
          </span>
        )}

        <Listbox
          value={selected}
          onChange={(value) => {
            setSelected(value);
          }}
        >
          {({ open }) => (
            <div className="relative mt-6 text-left ">
              <Listbox.Button className="relative w-full cursor-pointer rounded-full bg-white py-2 px-6 pr-10 text-left text-bbc-gray focus:outline-none focus-visible:border-indigo-500 focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75 focus-visible:ring-offset-2 focus-visible:ring-offset-orange-300 sm:text-sm">
                <span className="block truncate  text-base">
                  {selected.name}
                </span>
                <span className="pointer-events-none absolute inset-y-0 right-1 flex items-center pr-2">
                  <FiChevronDown
                    size={20}
                    className={`absolute right-3  float-right transform align-middle text-bbc-brand-500  ${
                      open ? "rotate-180" : "rotate-0"
                    } transition-all duration-200`}
                    aria-hidden="true"
                  />
                </span>
              </Listbox.Button>

              <Listbox.Options className="absolute mt-1 max-h-60 w-full overflow-auto rounded-xl bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm">
                {suffix_data.CompanySuffixes.map((suffix) => (
                  <Listbox.Option
                    key={suffix.id}
                    className={({ active }) =>
                      `relative cursor-default select-none py-2 pl-10 pr-4 ${
                        active
                          ? "bg-bbc-brand-100 text-bbc-brand-800"
                          : "text-gray-900"
                      }`
                    }
                    value={suffix}
                  >
                    {({ selected }) => (
                      <>
                        <span
                          className={`block truncate ${
                            selected ? "font-medium" : "font-normal"
                          }`}
                        >
                          {suffix.name}
                        </span>
                        {selected ? (
                          <span className="absolute inset-y-0 left-0 flex items-center pl-3 text-bbc-brand-400">
                            <FaCaretRight
                              className="h-5 w-5"
                              aria-hidden="true"
                            />
                          </span>
                        ) : null}
                      </>
                    )}
                  </Listbox.Option>
                ))}
              </Listbox.Options>
            </div>
          )}
        </Listbox>
      </div>
      <ButtonNew
        type="button"
        othersClass={"mt-6"}
        onClick={() => {
          if (getValues("company_name") === "") {
            setCompanyNameError(true);
          } else {
            setStep(step + 1);
          }
        }}
      >
        Next
      </ButtonNew>
    </>
  );
};

export default Step1;
